<template>
  <div>
    <div class="homeview-content" v-if="ishome">
      <div class="homeview-main">
        <!-- 粒子背景画布 -->
        <canvas id="particle-canvas" ref="particleCanvas"></canvas>
        <Homemain @goanalysis="goanalysis"></Homemain>
      </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Homemain from "@/views/newtheme/newhome/homemain.vue";

export default {
  components: {
    Homemain,
  },
  data() {
    return {
      ishome: true,
      animationFrameId: null,
    };
  },
  watch: {
    "$route.path"(toPath, fromPath) {
      if (toPath == "/home") {
        this.ishome = true;
        this.$nextTick(() => this.initParticles());
      } else {
        this.ishome = false;
        this.destroyParticles();
      }
    },
  },
  methods: {
    goanalysis(data) {
      this.ishome = false;
      console.log("打印一下我这个data");
      console.log(data);
      this.$router.push({
        path: `/home/addressdetail/${data.address}`,
        query: { data: JSON.stringify(data) },
      });
    },
    initParticles() {
      const canvas = document.getElementById("particle-canvas");
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      let particles = [];

      const resize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        particles = [];
        const count = Math.floor((canvas.width * canvas.height) / 10000);
        for (let i = 0; i < count; i++) {
          particles.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 2.2 + 1.2,
            vx: (Math.random() - 0.5) * 0.45,
            vy: (Math.random() - 0.5) * 0.45,
          });
        }
      };

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach((p, i) => {
          p.x += p.vx;
          p.y += p.vy;
          if (p.x > canvas.width || p.x < 0) p.vx *= -1;
          if (p.y > canvas.height || p.y < 0) p.vy *= -1;

          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fillStyle = "rgba(59, 130, 246, 0.55)";
          ctx.fill();

          for (let j = i + 1; j < particles.length; j++) {
            const p2 = particles[j];
            const dist = Math.hypot(p.x - p2.x, p.y - p2.y);
            if (dist < 160) {
              ctx.beginPath();
              ctx.moveTo(p.x, p.y);
              ctx.lineTo(p2.x, p2.y);
              ctx.strokeStyle = `rgba(59, 130, 246, ${0.4 * (1 - dist / 160)})`;
              ctx.lineWidth = 0.7;
              ctx.stroke();
            }
          }
        });
        this.animationFrameId = requestAnimationFrame(draw);
      };

      window.addEventListener("resize", resize);
      resize();
      draw();
    },
    destroyParticles() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
  },
  created() {
    if (this.$route.path == "/home") {
      this.ishome = true;
      this.$nextTick(() => this.initParticles());
    } else {
      this.ishome = false;
    }
  },
  beforeDestroy() {
    this.destroyParticles();
    window.removeEventListener("resize", this.initParticles);
  },
};
</script>
<style lang="less">
.homeview-main {
  height: calc(100vh - 64px);
  position: relative;
  overflow: hidden;

  canvas#particle-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }
}
</style>
